module.exports = __webpack_public_path__ + "static/media/contest-dashboard-all-2-player.67fe7f32.png";